// tanstack
import { createFileRoute } from '@tanstack/react-router';

// material ui
import { Card, CardContent, Container } from '@mui/material';

// api
import { useGetEnergyDataQuery } from '@/api/energy-analysis/energyDataApiSlice';
import { useGetEnergyGroupQuery } from '@/api/generated/recalc/endpoints/v2/energyGroups';

// shared components
import PageHeader from '@/components/layout/PageHeader';
import GatewayLoadingIndicator from '@/components/ui/progress/GatewayLoadingIndicator';

// feature-components
import NodeTimeRangeGraph from '@/features/service-manager/components/energyxplorer/deep-dive/NodeTimeRangeGraph';

import { DateTime } from 'luxon';

export const Route = createFileRoute(
  '/$accountId/_admin/operations/deep-dive/$groupId',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { groupId } = Route.useParams();
  const { data: energyGroup, isLoading } = useGetEnergyGroupQuery({ groupId });

  const queryArgs = {
    accountId: energyGroup?.accountId,
    energyGroupId: energyGroup?.energyGroupId,
    start: DateTime.now().minus({ days: 2 }).toMillis(),
    end: DateTime.now().minus({ days: 1 }).toMillis(),
  };

  const { data: energyData } = useGetEnergyDataQuery(queryArgs, {
    refetchOnMountOrArgChange: true, // 👈 critical
    skip: !queryArgs?.energyGroupId || !queryArgs?.accountId,
  });

  return (
    <Container maxWidth={false} sx={{ py: 2 }}>
      <GatewayLoadingIndicator isLoading={isLoading} />
      <PageHeader title={energyGroup?.name || 'Deep Dive'} />
      <Card>
        <CardContent>
          <NodeTimeRangeGraph energyData={energyData} />
        </CardContent>
      </Card>
    </Container>
  );
}
